import React, { Component } from 'react';
import classNames from 'classnames';
import withStyles from '@mui/styles/withStyles';
import { Button, IconButton, Tooltip, Typography } from '@mui/material';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
import CloseIcon from '@mui/icons-material/Close';
import Save from '@mui/icons-material/Save';
import Add from '@mui/icons-material/Add';
import SavingSpinner from './SavingSpinner';

import AppBindStyles from '../../AppBindStyles';
import { green } from '@mui/material/colors';

const styleSheet = theme => ({
    root: {
        flexGrow: 1,
    },
    flex: {
        flex: 1,
    },
    close: {
        padding: theme.spacing(0.5),
    },    
    success: {
        backgroundColor: green[300],
    },
    error: {
        backgroundColor: theme.palette.error.light,
    },
    icon: {
        fontSize: 20,
    },
    iconVariant: {
        opacity: 0.9,
        marginRight: theme.spacing(1),
    },
    message: {
        display: 'flex',
        alignItems: 'center',
    },
});

class SaveButton extends Component {
    // Save button / snackbar should be largely managed by parent components.  So manage open/close
    // at the parent level (requiring a state property on that component.)
    //
    // Props for SaveButton are:
    // - buttonType: Save or Add (defaults to Save)
    // - snackbarOpen: Snackbar open or not
    // - autoHideDuration: milliseconds to display before disappearing
    // - onSaveClick: Button onClick event (what to do when hitting Save)
    // - onSnackbarClose: Snackbar on close event (what to do when snackbar closes)
    // - status: none, saving, success, error
    // - message: save or error message
    // - label: optional label
    // - size: optional size
    // - buttonStyle: an AppBindStyles or other style setting

    render() {
        const classes = this.props.classes;
        let theVariant = this.props.variant;
        if (theVariant == null) {
            theVariant = "contained";
        }

        let theColor = this.props.color;
        if (theColor == null) {
            theColor = "primary";
        }

        let theType = 'save';
        let theLabel = 'Save';
        if (this.props.buttonType === 'add') {
            theType = 'add';
            theLabel = 'Add';
        }

        if (this.props.label) {
            theLabel = this.props.label;
        }

        let iconMode = 'text';
        if (this.props.iconMode === 'both') {
            iconMode = 'both';
        } else if (this.props.iconMode === 'icon') {
            iconMode = 'icon';
        }

        let theButtonStyle = AppBindStyles.bottomButton;
        if (this.props.buttonStyle) {
            if (this.props.buttonStyle !== "none") {
                theButtonStyle = this.props.buttonStyle;
            } else {
                theButtonStyle = null;
            }
        }

        return (
            <div style={{display:'inline'}}>
                {this.props.status !== 'saving' && iconMode !== 'icon' &&
                    <Button disabled={this.props.disabled} 
                            id="save-button"
                            variant={theVariant} color={theColor} 
                            size={this.props.size}
                            style={theButtonStyle}
                            onClick={this.props.onSaveClick}>
                        {iconMode === 'text' &&
                        <React.Fragment>{theLabel}</React.Fragment>}
                        {iconMode === 'both' && theType === 'add' &&
                        <React.Fragment><Add/>&nbsp;&nbsp;{theLabel}</React.Fragment>}
                        {iconMode === 'both' &&theType === 'save' &&
                        <React.Fragment><Save/>{theLabel}</React.Fragment>}
                    </Button>
                }
                {this.props.status !== 'saving' && iconMode === 'icon' &&
                    <Tooltip title={theLabel}>
                        <Button disabled={this.props.disabled} 
                                id="save-button"
                                variant={theVariant} color={theColor} 
                                size={this.props.size}
                                style={theButtonStyle}
                                onClick={this.props.onSaveClick}>
                            {theType === 'add' &&
                            <Add/>}
                            {theType === 'save' &&
                            <Save/>}
                        </Button>
                    </Tooltip>
                }
                {this.props.status === 'saving' && 
                    <Button color="primary" variant="contained" 
                        size={this.props.size}
                        style={theButtonStyle}
                        >
                        <SavingSpinner/>
                    </Button>
                }
                
                {/* open={(this.props.status === 'success' || this.props.status === 'error') && this.state.open} */}
                <Snackbar
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    open={this.props.snackbarOpen}
                    autoHideDuration={this.props.autoHideDuration}
                    onClose={this.props.onSnackbarClose}
                >
                    <SnackbarContent
                        className={classNames(classes.message, classes[this.props.status])}
                        onClose={this.props.onSnackbarClose}
                        message={
                            <Typography variant="body1">
                                {this.props.message}
                            </Typography>
                        }
                        action={[
                            <IconButton
                                key="close"
                                aria-label="Close"
                                color="inherit"
                                className={classes.close}
                                onClick={this.props.onSnackbarClose}
                                size="large">
                            <CloseIcon />
                            </IconButton>
                        ]}
                    />
                </Snackbar>
            </div>
        );
    }
}
  
export default withStyles(styleSheet)(SaveButton);